import { StyledSelectFolderList } from "./style";
import { Icon } from "components/icon/Icon";
import { useRef, useState } from "react";
import DropdownListPortal from "components/portal/DropdownListPortal/DropdownListPortal";
import { DropDownListOptionType } from "types/common/CommonType";
import styled from "styled-components";
import { CustomScrollContainer } from "components/scrollbar/CustomScollBarContainer/CustomScrollBarContainer";
import useResizeObserver from "hooks/Observer/useResizeObserver";
import { SelectListForm } from "../InputForm/SelectListForm/SelectListForm";

export interface SelectFolderListProps {
  size: "small" | "medium" | "large";
  options: DropDownListOptionType[];
  value: DropDownListOptionType;
  handleValue?: (value: DropDownListOptionType) => void;
}

const StyledDropDownList = styled.div`
  display: block;
  box-sizing: border-box;
  border: 0.1rem solid var(--text-gray-strong);
  background-color: var(--bg-gray-normal);
  border-radius: 0.4rem;
  padding: 0.3rem 0;
`;

export const SelectFolderList = ({
  size,
  value,
  options,
  handleValue,
}: SelectFolderListProps) => {
  const parentRef = useRef<HTMLDivElement | null>(null);
  const { rect: parentRect } = useResizeObserver(parentRef);
  const [isDropdown, setIsDropdown] = useState<boolean>(false);
  return (
    <StyledSelectFolderList $size={size} $isOpen={isDropdown}>
      <div className="field-wrap">
        <div
          className="field"
          onClick={() => setIsDropdown(!isDropdown)}
          ref={parentRef}
        >
          <p className="value">{value.label}</p>
          <Icon
            icon="ChevronUp"
            size={size === "large" ? 20 : size === "medium" ? 16 : 12}
            stroke="--text-gray-strong"
            rotate={isDropdown ? 0 : 180}
          />
        </div>
      </div>
      {isDropdown && parentRect && (
        <DropdownListPortal onClose={() => setIsDropdown(false)}>
          <StyledDropDownList
            style={{
              position: "absolute",
              left: parentRect.left + "px",
              top: parentRect.top + parentRect.height + 5 + "px",
            }}
          >
            <CustomScrollContainer
              width={parentRect.width - 2 + "px"}
              height="max-content"
              maxHeight={
                size === "large"
                  ? "110px"
                  : size === "medium"
                    ? "130px"
                    : "150px"
              }
            >
              {options.map((option, idx) => (
                <SelectListForm
                  key={`${option.value}-${idx}`}
                  size={size}
                  option={option}
                  value={value}
                  handleValue={handleValue}
                  onClick={() => setIsDropdown(false)}
                />
              ))}
            </CustomScrollContainer>
          </StyledDropDownList>
        </DropdownListPortal>
      )}
    </StyledSelectFolderList>
  );
};
